var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMigrateAccountsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8794 5.77586C20.9099 5.84937 20.9544 5.91607 21.0107 5.97209L23.5858 8.54685C23.7381 8.70455 23.964 8.76768 24.1762 8.71225C24.3885 8.65682 24.5542 8.49082 24.6096 8.27858C24.6653 8.06634 24.6019 7.84076 24.4442 7.6884L22.9046 6.14935H28.724C29.7301 6.14935 30.5452 6.96482 30.5452 7.97059V12.2202C30.5452 12.5554 30.8171 12.8272 31.1523 12.8272C31.4876 12.8272 31.7594 12.5554 31.7594 12.2202V7.97059C31.7576 6.2949 30.3997 4.93727 28.724 4.93519H22.9046L24.4442 3.39615C24.6019 3.24379 24.6653 3.01821 24.6096 2.80596C24.5542 2.59372 24.3885 2.42772 24.1762 2.37229C23.964 2.31686 23.7381 2.38 23.5858 2.5377L21.0107 5.11245C20.9544 5.16848 20.9099 5.23517 20.8794 5.30869C20.8162 5.45809 20.8162 5.62646 20.8794 5.77586Z",
    fill: "#1E247E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3569 28.5029C18.3263 28.4294 18.2819 28.3627 18.2256 28.3067L15.6505 25.7319C15.4978 25.5742 15.2723 25.5111 15.06 25.5665C14.8478 25.6219 14.6821 25.7879 14.6264 26.0002C14.5709 26.2124 14.6341 26.438 14.7921 26.5904L16.3317 28.1294H10.512C9.50619 28.1294 8.69072 27.3139 8.69072 26.3082V22.6657C8.69072 22.3304 8.4189 22.0586 8.08364 22.0586C7.74839 22.0586 7.47656 22.3304 7.47656 22.6657V26.3082C7.47864 27.9839 8.83656 29.3415 10.512 29.3436H16.3317L14.7921 30.8826C14.6341 31.035 14.5709 31.2605 14.6264 31.4728C14.6821 31.685 14.8478 31.851 15.06 31.9065C15.2723 31.9619 15.4978 31.8988 15.6505 31.7411L18.2256 29.1663C18.2819 29.1103 18.3263 29.0436 18.3569 28.9701C18.42 28.8207 18.42 28.6523 18.3569 28.5029Z",
    fill: "#1E247E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8658 18.592H1.57808C1.27811 18.592 1.03516 18.3491 1.03516 18.0491V16.7822C1.03516 16.4822 1.27811 16.2393 1.57808 16.2393H17.8658C18.1657 16.2393 18.4087 16.4822 18.4087 16.7822V18.0491C18.4087 18.3491 18.1657 18.592 17.8658 18.592Z",
    fill: "#DA867D",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52024 1.19025L1.37638 4.52028C1.17034 4.6028 1.03516 4.80232 1.03516 5.02438V6.43028C1.03516 6.73025 1.27811 6.9732 1.57808 6.9732H17.8658C18.1657 6.9732 18.4087 6.73025 18.4087 6.43028V5.02438C18.4087 4.80232 18.2735 4.6028 18.0675 4.52028L9.92363 1.19025C9.79414 1.1384 9.64972 1.1384 9.52024 1.19025Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72266 3.49902V4.65735",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08982 16.2394H2.77344V6.97363H5.08982V16.2394Z",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8789 16.2394H8.5625V6.97363H10.8789V16.2394Z",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6719 16.2394H14.3555V6.97363H16.6719V16.2394Z",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 33.6799H21.3789C21.0789 33.6799 20.8359 33.4369 20.8359 33.137V31.8701C20.8359 31.5701 21.0789 31.3271 21.3789 31.3271H37.6666C37.9665 31.3271 38.2095 31.5701 38.2095 31.8701V33.137C38.2095 33.4369 37.9665 33.6799 37.6666 33.6799Z",
    fill: "#DA867D",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.321 16.2781L21.1772 19.6082C20.9711 19.6907 20.8359 19.8902 20.8359 20.1123V21.5182C20.8359 21.8181 21.0789 22.0611 21.3789 22.0611H37.6666C37.9665 22.0611 38.2095 21.8181 38.2095 21.5182V20.1123C38.2095 19.8902 38.0743 19.6907 37.8683 19.6082L29.7244 16.2781C29.5949 16.2263 29.4505 16.2263 29.321 16.2781Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5234 18.5869V19.7452",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8906 31.3273H22.5742V22.0615H24.8906V31.3273Z",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6797 31.3273H28.3633V22.0615H30.6797V31.3273Z",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4726 31.3273H34.1562V22.0615H36.4726V31.3273Z",
    stroke: "#1E247E",
    strokeWidth: 0.948659,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrateAccountsIcon);
export default __webpack_public_path__ + "static/media/MigrateAccountsIcon.d7449c2df6fbc168a3bb2571410bd532.svg";
export { ForwardRef as ReactComponent };